import type { ReactNode } from 'react';
import { useGuestGuard } from '@core/auth/hooks/useGuestGuard';

interface GuestRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

/**
 * Route wrapper that only allows unauthenticated (guest) users.
 * Authenticated users are redirected to home or dashboard based on their role.
 */
export function GuestRoute({ children, redirectTo }: GuestRouteProps) {
  const { isGuest, isLoading } = useGuestGuard({ redirectTo });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isGuest) {
    return null;
  }

  return <>{children}</>;
}
